import { IonImg } from '@ionic/react'

export default function PasskeyIcon() {
  return <IonImg src='/biometrics.png' alt='Image of a lock with a fingerprint in it' />
}
